import { Timestamp } from 'firebase/firestore';

export type PlanType = 'freemium' | 'trialPremium' | 'enterprise' | 'trial';

// Exportar PLAN_IDS como valor
export const PLAN_IDS = {
  freemium: 'dohMh0KPeyZU8rFDMSB1',
  trialPremium: 'az3qFtboiMPUnI7t3SoW', // ID real del plan profesional
  enterprise: 'ent_plan_id',    // ID real del plan enterprise
  trial: 'trial_plan_id'        // ID real del plan trial
} as const;

export interface PlanFeature {
  id: string;
  name: string;
  description?: string;
  limit?: number;
}

export interface Plan {
  createdAt: Timestamp;
  currency: string;
  description: string;
  features: {
    maxShipmentsPerMonth: number;
    maxTeamMembers: number;
    prioritySupport: boolean;
  };
  isFreemium: boolean;
  isTrial: boolean;
  name: string;
  price: number;
  trialPeriodDays: number;
  updatedAt: Timestamp;
}

export interface UserPlan {
  active?: boolean;
  cancelAtPeriodEnd?: boolean;
  createdAt?: string;
  planId?: string;
  renewalDate?: string | null;
  trialEndDate?: string | null;
  trialStartDate?: string;
  updatedAt?: string;
  userId?: string;
  startDate?: Date;
  status?: 'active' | 'inactive' | 'suspended';
}
